var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolInfobox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tools/infobox"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3463340",
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 4,
    fill: "#DEEFFD"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0081 5.65332C12.8653 5.65332 13.5 6.15276 13.5 7.09905C13.5 8.08648 12.8653 8.65332 12.0081 8.65332C11.1338 8.65332 10.5 8.08648 10.5 7.09905C10.5 6.15276 11.1338 5.65332 12.0081 5.65332Z",
    fill: "#007BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2407 18.3471V9.89905H10.7394V18.3471H13.2407Z",
    fill: "#007BFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolInfobox);
export default __webpack_public_path__ + "static/media/toolInfobox.44be0f37646c6cf69149d777f7231c48.svg";
export { ForwardRef as ReactComponent };